import { render, staticRenderFns } from "./sbchistoryMsg.vue?vue&type=template&id=1240c5c4&"
import script from "./sbchistoryMsg.vue?vue&type=script&lang=js&"
export * from "./sbchistoryMsg.vue?vue&type=script&lang=js&"
import style0 from "./sbchistoryMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports